module.exports = __webpack_public_path__ + "img/KITrainerIllustration.50677485.png";